<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Transactions</h5>
  <div class="d-flex align-items-center gap-2  ms-auto">
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
</div>

<div class="modal-body p-2">


 <div class="d-flex justify-content-end mb-2">
    <button type="button" class="btn btn-success btn-sm" (click)="addTransaction()">
      <fa-icon [icon]="faPlus"></fa-icon> Add Transaction
    </button>
  </div>

  <div class="table-responsive m-2">
    <table class="table table-sm table-hover mb-0 small">
      <thead>
        <tr>
          <th>Type</th>
          <th>Method</th>
          <th>Date</th>
          <th>A/c From</th>
          <th>A/c To</th>
          <th>Received Date</th>
          <th>Received From</th>
          <th>Narrative</th>
          <th>Invoice No</th>
          <th>Value</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let transaction of transactionsAdded"
          [ngClass]="{
            'table-success': transaction.klyantId != null,
            'table-warning': transaction.klyantId == null
          }">
          <td>{{transaction.type}}</td>
          <td>
            <span *ngIf="transaction.transactionTypeId != null">
              {{transaction.transactionType.type}}
              <span *ngIf="transaction.transactionTypeOther != null">({{transaction.transactionTypeOther}})</span>
              <span *ngIf="transaction.transactionType.type == 'Cheque' && transaction.chequeDetails?.length > 0">({{transaction.chequeDetails}})</span>
            </span>
          </td>
          <td>{{transaction.transactionDateTime | date:'dd/MM/yyyy'}}</td>
          <td>
            <span *ngIf="transaction.transactionDirection == 2 || transaction.transactionDirection == 3">
              {{getClientAccountName(transaction.fromBankAccountId)}}
            </span>
          </td>
          <td>
            <span *ngIf="transaction.transactionDirection == 1">{{getClientAccountName(transaction.toBankAccountId)}}</span>
            <span *ngIf="transaction.transactionDirection == 2">{{getOfficeAccountName(transaction.toBankAccountId)}}</span>
          </td>
          <td>{{transaction.fundsReceivedDate | date:'dd/MM/yyyy'}}</td>
          <td>{{transaction.fundsReceivedFrom}}</td>
          <td>{{transaction.narrative}}</td>
          <td>{{transaction.invoice?.invoiceNumber}}</td>
          <td>{{transaction.value | currency:'£'}}</td>
          <td>
            <div class="d-flex gap-2">
              <fa-icon [icon]="faTimes" class="text-danger" style="cursor:pointer;"
                (click)="removeTransaction(transaction)"></fa-icon>
              <fa-icon *ngIf="transaction.klyantId == null && !transaction.sendingToKlyant"
                [icon]="faShare" class="text-success" style="cursor:pointer;"
                (click)="sendToKlyant(transaction)"></fa-icon>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="px-3 py-2 fw-bold">
    Balance: {{balance | currency:'£'}}
  </div>
</div>